<template>
    <div>
        <vx-card>
            <vs-tabs>
                <vs-tab :label="$t('menuOrganization.personalInformation')">
                    <div>
                        <div class="vx-row">
                            <div class="vx-col md:w-3/4 w-full">
                                <!-- Col Header -->
                                <div class="flex items-end mt-6 mb-3">
                                    <feather-icon icon="SidebarIcon" class="mr-2" svgClasses="w-6 h-6" />
                                    <span class="leading-none font-medium fsz font-bold">{{
                    $t('menuOrganization.unitDepartment') }}</span>
                                </div>

                                <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.branch') }} </label>
                                        <span class="text-danger">*</span>
                                        <v-select class="" v-model="branchModel" :clearable="false"
                                            :options="branchOptions" data-vv-validate-on="blur" v-validate="'required'"
                                            name="branch">
                                            <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                                        </v-select>
                                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                                    </div>

                                    <div class="vx-col md:w-1/3 w-full mt-2" v-if="!isCreateDepartment">
                                        <label class="vs-input--label">{{ $t('menuOrganization.department') }} </label>
                                        <v-select class="" v-model="departmentModel" :clearable="false"
                                            :options="departmentOptions" data-vv-validate-on="blur">
                                            <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                                        </v-select>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2" v-if="isCreateDepartment">
                                        <label class="vs-input--label">{{
                    $t('menuOrganization.createDepartment')
                }}</label>
                                        <vs-input class="w-full" v-model="departmentName" name="departmentName" />
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-6">
                                        <vs-button class="mt-2" type="border"
                                            v-if="!isCreateDepartment & isPermissionEdit()" @click="createDepartment">{{
                    $t('button.addNew') }}
                                        </vs-button>
                                        <vs-button class="mt-2" type="border"
                                            v-if="isCreateDepartment & isPermissionEdit()" @click="saveDepartment">
                                            {{ $t('button.save') }}
                                        </vs-button>
                                        <vs-button class="ml-4 mt-2" type="border"
                                            v-if="isCreateDepartment & isPermissionEdit()"
                                            @click="cancelCreateDeparment">{{ $t('button.back') }}
                                        </vs-button>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <!--                                    <div class="vx-col md:w-1/3 w-full mt-2">-->
                                    <!--                                        <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.position') }} </label>-->
                                    <!--                                        <vs-input class="w-full" v-model="employeeInfo.position" v-validate=""-->
                                    <!--                                                  name="position"/>-->
                                    <!--                                        <span class="text-danger text-sm">{{ errors.first('position') }}</span>-->
                                    <!--                                    </div>-->
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.positions') }}</label>
                                        <v-select multiple v-model="selectedPositions" :options="positionOptions"
                                            :clearable="false" v-validate="" name="poisition">
                                            <span slot="no-options"> {{ $t('root.noRowsToShow') }} </span>
                                        </v-select>

                                        <span class="text-danger text-sm">{{ errors.first('positions') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.contractType') }}
                                        </label>
                                        <v-select class="" v-model="employeeTypeModel" :clearable="false"
                                            :options="employeeTypeOptions" data-vv-validate-on="blur" v-validate="''"
                                            name="type">
                                            <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                                        </v-select>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.employeeType') }}
                                        </label>
                                        <v-select class="" v-model="employeeInfo.employmentType" :clearable="false"
                                            :options="employmentTypeOptions" data-vv-validate-on="blur" v-validate="''"
                                            name="employmentType" :reduce="(option) => option.value">
                                            <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                                        </v-select>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">Lương tiết trợ giảng</label>
                                        <vs-input class="w-full" v-model="formattedExtraSalary"
                                            type="text" @input="formatInputMoney" />
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">Lương tiết dạy</label>
                                        <vs-input class="w-full" v-model="formattedSalary" @input="formatInput"
                                            type="text" />
                                    </div>
                                    <div class="vx-col md:w-2/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('classRoom.classRoom') }}</label>
                                        <v-select v-model="selectedClassroom" :options="dataClassPermission"
                                            label="className" multiple>
                                            <template #option="{ className, organizationBranchName }">
                                                <h5 style="margin: 0">{{ className }}</h5>
                                                <em>{{ organizationBranchName }}</em>
                                            </template>
                                            <template #selected-option="{ className, organizationBranchName }">
                                                <div class="flex items-center gap-2">
                                                    <strong>{{ className }}</strong>
                                                    <em>{{ organizationBranchName }}</em>
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                    <!--                                    <div class="vx-col md:w-1/3 w-full mt-2">-->
                                    <!--                                        <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.salary') }} <span-->
                                    <!--                                                class="text-danger">*</span></label>-->
                                    <!--                                        <vs-input class="w-full" v-model="employeeInfo.salary"-->
                                    <!--                                            v-validate="'required|numeric'" name="salary" />-->
                                    <!--                                        <span class="text-danger text-sm">{{ errors.first('salary') }}</span>-->
                                    <!--                                    </div>-->
                                </div>
                                <!-- <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.positions') }}</label>
                                        <span class="text-danger text-sm">*</span>
                                        <v-select multiple v-model="selectedPositions" :options="positionOptions"
                                            :clearable="false" v-validate="" name="poisition">
                                            <span slot="no-options"> {{ $t('root.noRowsToShow') }} </span>
                                        </v-select>

                                        <span class="text-danger text-sm">{{ errors.first('positions') }}</span>
                                    </div>
                                </div> -->
                            </div>
                            <div class="vx-col md:w-1/4 w-full" style="border-left: 1px solid #DCDCDC;">
                                <!-- Col Header -->
                                <div class="mt-6 mb-3 flex justify-center items-end">
                                    <feather-icon icon="MaximizeIcon" class="mr-2" svgClasses="w-6 h-6" />
                                    <span class="leading-none font-medium fsz font-bold">{{
                    $t('menuCustomer.faceData')
                }}</span>
                                </div>
                                <div class="vx-row">
                                    <vue-upload-multiple-image class="m-auto" @upload-success="uploadImageSuccess"
                                        @before-remove="beforeRemove" @edit-image="editImage" @data-change="dataChange"
                                        :data-images="images" :dragText="$t('menuOrganization.dragText')">
                                    </vue-upload-multiple-image>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mt-4">
                            <div class="vx-col w-full">
                                <!-- Col Header -->
                                <div class="flex items-end mt-8 mb-3">
                                    <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-6 h-6" />
                                    <span class="leading-none font-medium fsz font-bold">{{
                    $t('menuOrganization.backgroundContact') }}</span>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.employeeCode') }}
                                            <span class="text-danger">*</span></label>
                                        <vs-input class="w-full" v-model="employeeInfo.employeeCode"
                                            v-validate="'required|max:20'" name="employeeCode" />
                                        <span class="text-danger text-sm">{{ errors.first('employeeCode') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/4 w-full flex mt-8" v-show="isUpdate">
                                        <vs-checkbox v-model="employeeInfo.enabled" class="mb-1"></vs-checkbox>
                                        <span class="mt-2">{{ $t('menuOrganization.working') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-8 flex" v-if="isShowManagerDepartment">
                                        <vs-radio v-model="employeeInfo.departmentType" vs-value="1" class="mr-4"
                                            vs-name="layout-type-vertical">{{ $t('timeKeeping.teacher') }}
                                        </vs-radio>
                                        <vs-radio v-model="employeeInfo.departmentType" vs-value="0" class="mr-4"
                                            vs-name="layout-type-vertical">{{ $t('dashboard.employee') }}
                                        </vs-radio>
                                        <!-- <vs-radio v-model="employeeInfo.departmentType" vs-value="4" class="mr-4"
                                            vs-name="layout-type-vertical">Cả 2
                                        </vs-radio> -->
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.lastName') }} <span
                                                class="text-danger">*</span></label>
                                        <vs-input class="w-full" v-model="lastNameModel" v-validate="'required'"
                                            name="lastName" />
                                        <span class="text-danger text-sm">{{ errors.first('lastName') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.firstName') }} <span
                                                class="text-danger">*</span></label>
                                        <vs-input class="w-full" v-model="firstNameModel" v-validate="'required'"
                                            name="firstName" />
                                        <span class="text-danger text-sm">{{ errors.first('firstName') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <vx-input-group class="">
                                            <label class="vs-input--label">{{ $t('menuOrganization.userName') }}
                                                <span class="text-danger">*</span></label>
                                            <vs-input class="w-full" :disabled="isUpdate" v-model="userNameModel"
                                                @input="checkLengthUserName" v-validate="'required|max:50'"
                                                name="userName" />
                                            <template v-if="!isUpdate" slot="append">
                                                <div class="append-text btn-addon mt-6">
                                                    <vs-button :disabled="isMaxLength" @click="checkUserName()"
                                                        color="primary" style="height: 38px">
                                                        {{ $t('button.check') }}
                                                    </vs-button>
                                                </div>
                                            </template>
                                        </vx-input-group>
                                        <span class="text-danger text-sm">{{ errors.first('userName') }}</span>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.birthday') }} <span
                                                class="text-danger">*</span></label>
                                        <!-- <vs-input class="w-full" v-model="employeeInfo.birthday" v-validate="'required'"
                                            name="birthday" placeholder="DD/MM/YYYY" type="date"
                                           /> -->
                                        <flat-pickr v-model="employeeBirthday" v-validate="'required'"
                                            :config="dateConfig" name="birthday" placeholder="DD/MM/YYYY"
                                            class="w-full" />
                                        <span class="text-danger text-sm">{{ errors.first('birthday') }}</span>
                                    </div>

                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">Email</label>
                                        <span class="text-danger">*</span>
                                        <vs-input class="w-full" v-model="employeeInfo.email"
                                            v-validate="'required|email'" name="email" />
                                        <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                                    </div>

                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.phoneNumber') }} </label>
                                        <vs-input class="w-full" v-model="employeeInfo.phoneNumber"
                                            v-validate="'phone_rule'" name="phoneNumber" />
                                        <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>
                                    </div>
                                    <div class="vx-col w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.gender') }} </label>
                                        <span class="text-danger">*</span>
                                        <div class="mt-2 ml-1">
                                            <vs-radio v-model="employeeInfo.gender" vs-value="0" class="mr-4">Chưa xác
                                                định
                                            </vs-radio>
                                            <vs-radio v-model="employeeInfo.gender" vs-value="1" class="mr-4">Nam
                                            </vs-radio>
                                            <vs-radio v-model="employeeInfo.gender" vs-value="2">Nữ</vs-radio>
                                        </div>
                                        <span class="text-danger text-sm">{{ errors.first('gender') }}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="vx-col md:w-1/4 w-full">
                                <div class="flex items-end mt-8 mb-3 ml-12">
                                    <feather-icon icon="RadioIcon" class="mr-2" svgClasses="w-6 h-6" />
                                    <span class="leading-none font-medium fsz font-bold">{{ $t('navMenu.externalDevice') }}</span>
                                </div>

                                <div class="vx-row">
                                    <div class="vx-col w-full">
                                        <vs-button class="mt-4 m-auto" icon-pack="feather" icon="icon-plus" @click="openPopupCard" v-if="!employeeInfo.cardId || !isUpdate">
                                            {{ $t('button.addCard') }}
                                        </vs-button>
                                        <vs-popup title="Chọn thẻ" :active.sync="activePopup">
                                            <div class="vx-row">
                                                <div class="vx-col w-full text-center" v-if="!listCards && listCards.length == 0">
                                                    <span>{{ $t('cardCustomer.noData') }}</span>
                                                </div>
                                                <div class="vx-col md:w-1/3 w-full" v-for="(card, indexCard) in listCards" :key="indexCard" v-else>
                                                    <div class="w-full" @click="chooseCard(card)">
                                                        <card-customer class="mt-4" :data="card" :isEdit="false"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </vs-popup>
                                    </div>
                                    <div class="vx-col w-full m-auto" v-show="employeeInfo.cardId" style="min-height:300px;max-width:300px">
                                        <card-customer style="min-height:300px" class="mt-4 " :data="employeeInfo" :isEdit="isUpdate && employeeInfo.cardId && employeeInfo.cardStaff" :disableCard="true" />
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <!-- Col Header -->
                        <div class="flex items-end mt-10 mb-3">
                            <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-6 h-6" />
                            <span class="leading-none font-medium fsz font-bold">Địa chỉ</span>
                        </div>

                        <div class="vx-row">
                            <div class="vx-col md:w-3/4 w-full">
                                <div class="vx-row">
                                    <!--                                    <div class="vx-col md:w-1/3 w-full mt-2">-->
                                    <!--                                        <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.city') }} </label>-->
                                    <!--                                        <v-select class="heightDropdown" v-model="province" :clearable="false"-->
                                    <!--                                                  :options="cityOptions"-->
                                    <!--                                                  data-vv-validate-on="blur" v-validate="''" name="city">-->
                                    <!--                                            <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>-->
                                    <!--                                        </v-select>-->
                                    <!--                                        <span class="text-danger text-sm">{{ errors.first('city') }}</span>-->
                                    <!--                                    </div>-->
                                    <!--                                    <div class="vx-col md:w-1/3 w-full mt-2">-->
                                    <!--                                        <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.district') }} </label>-->
                                    <!--                                        <v-select class="heightDropdown" v-model="district" :clearable="false"-->
                                    <!--                                                  :options="districtOptions"-->
                                    <!--                                                  data-vv-validate-on="blur" v-validate="''" name="district">-->
                                    <!--                                            <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>-->
                                    <!--                                        </v-select>-->
                                    <!--                                        <span class="text-danger text-sm">{{ errors.first('district') }}</span>-->
                                    <!--                                    </div>-->

                                    <!--                                    <div class="vx-col md:w-1/3 w-full mt-2">-->
                                    <!--                                        <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.commune') }} </label>-->
                                    <!--                                        <v-select class="heightDropdown" v-model="subDistrict" :clearable="false"-->
                                    <!--                                                  :options="subDistrictOptions" data-vv-validate-on="blur"-->
                                    <!--                                                  v-validate="''"-->
                                    <!--                                                  name="subDistrict">-->
                                    <!--                                            <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>-->
                                    <!--                                        </v-select>-->
                                    <!--                                        <span class="text-danger text-sm">{{ errors.first('subDistrict') }}</span>-->
                                    <!--                                    </div>-->
                                    <!--                                    <div class="vx-col md:w-1/3 w-full mt-2">-->
                                    <!--                                        <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.houseNumber') }}</label>-->
                                    <!--                                        <vs-input class="w-full" v-model="employeeInfo.houseNumber"-->
                                    <!--                                                  v-validate="''" name="houseNumber"/>-->
                                    <!--                                        <span class="text-danger text-sm">{{ errors.first('houseNumber') }}</span>-->
                                    <!--                                    </div>-->
                                    <div class="vx-col w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.address') }} </label>
                                        <vs-input class="w-full" v-model="employeeInfo.fullAddress" v-validate="''"
                                            name="address" />
                                    </div>
                                </div>
                                <br>
                                <h5>{{ $t('menuOrganization.listFilesEmployee') }}</h5>
                                <div class="vx-row">
                                    <!-- AgGrid Table -->
                                    <ag-grid-vue style="height: 55vh;margin-left: 5px;" ref="agGridTable"
                                        :gridOptions="gridOptions" class="ag-theme-material w-full my-4 ag-grid-table"
                                        :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="filesGrid"
                                        :animateRows="true"
                                        :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                                        :onGridReady="onGridReady" :autoSizeStrategy="autoSizeStrategy">
                                    </ag-grid-vue>
                                </div>

                            </div>
                            <div class="vx-col md:w-1/4 w-full" style="border-left: 1px solid #DCDCDC;">
                                <!-- Col Header -->
                                <div class="mt-6 mb-3 flex justify-center items-end">
                                    <feather-icon icon="FileMinusIcon" class="mr-2" svgClasses="w-6 h-6" />
                                    <span class="leading-none font-medium fsz font-bold">{{
                    $t('employeeScreen.fileEmployee')
                }}</span>
                                </div>
                                <div class="flex justify-center">
                                    <div class="file-upload" @dragover="dragoverFile" @dragleave="dragleaveFile"
                                        @drop="dropFile">
                                        <input ref="fileUpload" type="file" id="fileUpload" multiple
                                            accept=".doc, .docx, .pdf, .epub" class="hidden" @change="uploadFile()">
                                        <div class="" v-if="files.length === 0">
                                            <div class="text-center">
                                                <feather-icon icon="UploadIcon" svgClasses="h-10 w-10 text-primary" />
                                            </div>
                                            <div class="text-center button-upload">
                                                <vs-button @click="$refs.fileUpload.click()">{{
                    $t('menuOrganization.selectedFile')
                }}</vs-button>
                                            </div>
                                            <div class="text-center mt-4">
                                                <label class="file-label text-primary">
                                                    <div v-if="isDragging">{{
                    $t('menuOrganization.releaseToDropTheFileHere') }}</div>
                                                    <div v-else>{{ $t('menuOrganization.dropFilesHere') }}</div>
                                                </label>
                                                <span><span class="text-md text-danger">*</span>{{
                    $t('menuOrganization.onlyFilesOfThisFormatAreSupported') }} <span
                                                        class="text-primary">.doc,
                                                        .docx, .pdf, .epub</span><span
                                                        class="text-md text-danger">*</span></span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="text-center">
                                                <svg data-v-5e4e33b8="" xmlns="http://www.w3.org/2000/svg" width="100px"
                                                    height="100px" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
                                                    class="feather feather-file-text text-primary">
                                                    <path data-v-5e4e33b8=""
                                                        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z">
                                                    </path>
                                                    <polyline data-v-5e4e33b8="" points="14 2 14 8 20 8"></polyline>
                                                    <line data-v-5e4e33b8="" x1="16" y1="13" x2="8" y2="13"></line>
                                                    <line data-v-5e4e33b8="" x1="16" y1="17" x2="8" y2="17"></line>
                                                    <polyline data-v-5e4e33b8="" points="10 9 9 9 8 9"></polyline>
                                                </svg>
                                            </div>
                                            <div class="text-center">
                                                <span>{{ fileSelect.name }}</span>
                                            </div>
                                            <div class="text-center">
                                                <vx-tooltip class="" :text="$t('button.delete')" position="top"
                                                    color="danger">
                                                    <feather-icon icon="XCircleIcon" svgClasses="h-5 w-5 text-danger"
                                                        @click="deleteFile" />
                                                </vx-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="show-list-file flex justify-center" v-if="files.length > 0">
                                    <div class="list-file flex flex-wrap gap-1">
                                        <div class="vx-col w-1/6 add-file" v-for="(file, ind) in files" :key="ind"
                                            @click="showFile(file, ind)">
                                            <vx-tooltip class="" :text="file.name" position="top">
                                                <svg data-v-5e4e33b8="" xmlns="http://www.w3.org/2000/svg" width="20px"
                                                    height="20px" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
                                                    class="feather feather-file-text text-primary">
                                                    <path data-v-5e4e33b8=""
                                                        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z">
                                                    </path>
                                                    <polyline data-v-5e4e33b8="" points="14 2 14 8 20 8"></polyline>
                                                    <line data-v-5e4e33b8="" x1="16" y1="13" x2="8" y2="13"></line>
                                                    <line data-v-5e4e33b8="" x1="16" y1="17" x2="8" y2="17"></line>
                                                    <polyline data-v-5e4e33b8="" points="10 9 9 9 8 9"></polyline>
                                                </svg>
                                            </vx-tooltip>
                                        </div>
                                        <div class="vx-col w-1/6 add-file" @click="$refs.fileUpload.click()">
                                            <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 text-primary" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="vx-row md:mb-1 mb-4 mt-4" v-for="(item, indexWork) in workShiftSetting"
                            :key="indexWork">
                            <div class="vx-col w-full mt-4" v-if="indexWork === 0">
                                <span class="ml-2 mt-6 font-bold" style="font-size: 18px">{{
                                        $t('menuOrganization.workingTime')
                                }}</span>
                            </div>
                            <div class="vx-col lg:w-1/2 w-full flex mt-4">
                                <vs-checkbox v-model="item.select" class="mb-1"></vs-checkbox>
                                <span>{{ item.displayWorkShift }}</span>
                            </div>
                            <div class="vx-col lg:w-1/2 w-full">
                              <div>{{item.displayWorkShift}}</div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full flex">
                                <vs-checkbox v-model="item.autoGenerateWorkShift" class="mb-1"></vs-checkbox>
                                <span class="mt-2">{{ $t('menuOrganization.autoGenerate') }}</span>
                            </div>
                        </div> -->

                        <!-- Save & Reset Button -->
                        <div class="vx-row mt-4">
                            <div class="vx-col w-full">
                                <div class="flex flex-wrap items-center justify-end">
                                    <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm"
                                        v-if="isPermissionEdit()">{{
                    `${isUpdate ?
                        $t('button.update') : $t('button.create')}`
                }}
                                    </vs-button>
                                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">
                                        {{ $t('button.back') }}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
                <!-- <vs-tab :label="$t('menuOrganization.authority')" v-if="isShowPermission">
                    <div class="mt-3">
                        <v-jstree :data="permissions" show-checkbox multiple allow-batch whole-row
                            @item-click="itemClick"></v-jstree>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="flex flex-wrap items-center justify-end">
                                <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{
                                        `${isUpdate ?
                                            $t('button.update') : $t('button.create')}`
                                }}
                                </vs-button>
                                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">
                                    {{ $t('button.back') }}
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </vs-tab> -->

                <vs-tab :label="$t('menuOrganization.rePass')" v-if="isUpdate & isPermissionEdit()">
                    <div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.branch') }} </label>
                                <span class="text-danger">*</span>
                                <v-select class="" v-model="branchModel" :clearable="false" :options="branchOptions"
                                    data-vv-validate-on="blur" :disabled="isUpdate" v-validate="'required'"
                                    name="branch" />
                                <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                            </div>
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.employeeCode') }} </label>
                                <span class="text-danger">*</span>
                                <vs-input class="w-full" :disabled="isUpdate" v-model="employeeInfo.employeeCode"
                                    v-validate="'required'" name="employeeCode" />
                                <span class="text-danger text-sm">{{ errors.first('employeeCode') }}</span>
                            </div>
                        </div>

                        <div class="vx-row">
                            <div class="vx-col md:w-2/3 w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.newPass') }} </label>
                                <span class="text-danger">*</span>
                                <vs-input id="iban" class="w-full" v-model="newPassword" v-validate="'required|min:6'"
                                    name="newPassword" @keypress="checkKeypressDrop($event)" />
                                <span class="text-danger text-sm">{{ errors.first('newPassword') }}</span>
                            </div>
                            <div class="vx-col w-full mt-2">
                                <div class="flex flex-wrap items-center justify-end">
                                    <vs-button class="ml-auto mt-2" @click="changePassword" :disabled="!validateForm">{{
                                        `${isUpdate ?
                                        $t('button.update') : $t('button.create')}`
                                        }}
                                    </vs-button>
                                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">
                                        {{ $t('button.back') }}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
            </vs-tabs>
        </vx-card>

    </div>
</template>

<script>
import CardCustomer from '../card-customer/card/CardCustomer.vue'
import vSelect from 'vue-select'
import province from '@/assets/utils/province.js';
import Datepicker from 'vuejs-datepicker';
import utils from "../../../components/utils";
import VueUploadMultipleImage from '../../../components/VueUploadMultipleImage'
import VJstree from 'vue-jstree';
import { en, vi } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
// import TitleScreen from "../../../layouts/main/TitleScreen";
import { isRouter } from '../../../store/permission';
import { constRouter } from '../../../store/constant';
import { AgGridVue } from "ag-grid-vue"
// import CellRendererStatus from "../class/cell-renderer/CellRendererStatus.vue";
// import CellRendererActions from "../class/cell-renderer/CellRendererActions.vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../ui-elements/Pagination.vue";

import CellRendererFilesActions from "./cell-renderer/CellRendererFilesActions.vue";
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Vietnamese } from 'flatpickr/dist/l10n/vn.js';

export default {
    components: {
        AgGridVue,
        vSelect,
        Datepicker,
        VueUploadMultipleImage,
        VJstree,
        // TitleScreen,
        CardCustomer,
        Pagination,
        // CellRendererStatus,
        // CellRendererActions
        CellRendererFilesActions,
        FlatPickr
    },
    data() {
        return {
            activePopup: false,
            cardCustomer: {
                cardId: null
            },
            dateConfig: {
                dateFormat: 'd/m/Y',
                allowInput: true,
                locale: Vietnamese,
            },
            // listCards: [],
            checkUsernameExisted: true,
            isMaxLength: false,
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            userInfo: {},
            en: en,
            vi: vi,
            departmentName: null,
            isCreateDepartment: false,
            isShowManagerDepartment: true,
            departmentOptions: [],
            isShowPermission: false,
            // permissions: [],
            privileges: [],
            images: [],
            imagesId: [],
            isUpdateImages: false,
            user_data: null,
            activeTab: 0,
            isUpdate: false,
            isUpdateFace: false,
            branchOptions: [],
            employeeInfo: {
                organizationBranchName: null,
                city: null,
                district: null,
                fullAddress: null,
                houseNumber: null,
                organizationBranchType: 0,
                organizationBranchId: this.$route.query.branch_id,
                phoneNumber: null,
                street: null,
                gender: 0,
                type: 0,
                salary: 0,
                departmentId: null,
                departmentType: 1,
                enabled: true,
                username: null,
                firstName: null,
                lastName: null,
                cardStaffId: null,
                cardStatus: null,
                cardNumber: null,
                cardStaffType: null,
                employmentType: null,
                teacherClassroomIds: [],
                mainLessonSalary:null,
                extraLessonSalary:null,

            },
            formattedExtraSalary: 0,
            formattedSalary: 0,
            // workShiftSetting: [],
            timeSpans: [],
            newPassword: null,
            genderOptions: [
                { value: 0, label: this.$t('genderOption.unknown') },
                { value: 1, label: this.$t('genderOption.male') },
                { value: 2, label: this.$t('genderOption.female') }
            ],
            employeeTypeOptions: [
                { value: 0, label: this.$t('employeeTypeOptions.unknown') },
                { value: 1, label: this.$t('employeeTypeOptions.trainee') },
                { value: 2, label: this.$t('employeeTypeOptions.officialStaff') }
            ],
            cityOptions: province.getProvince(),
            districtOptions: [],
            subDistrictOptions: [],
            file: [],
            fileName: this.$t('menuOrganization.addFace'),
            uploadPercent: 0,
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            positionOptions: [],
            selectedPositions: [],
            employmentTypeOptions: [
                { value: 0, label: this.$t('employeeTypeOptions.unknown') },
                { value: 1, label: 'Full-time' },
                { value: 2, label: 'Part-time' },
            ],
            files: [],
            filesGrid: [],
            isDragging: false,
            fileSelect: null,
            indexSelect: null,
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                flex: 1,
            },
            statusValue: null,
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            countElementPage: 0,
            totalElements: 0,
            totalPages: 0,
            currentPage: 1,
            pageNumber: 0,
            pageSize: 20,
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            columnDefs: [
                {
                    headerName: 'Tên',
                    field: 'name',
                    width: 100
                },
                {
                    headerName: 'Ngày tạo',
                    field: 'createdDate',
                    width: 200,
                    cellRenderer: (data) => {
                        return moment(data.value).format('DD/MM/YYYY HH:mm')
                    }
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRenderer: 'CellRendererFilesActions',
                }
            ],
            dataClassPermission: [],
            selectedClassroom: [],
            employeeBirthday: null,
        }
    },

    watch: {
        '$store.state.isDeleteFileEmployee'(val) {
            if (val) {
                this.files = this.files.filter(x => x.id !== val)
                this.filesGrid = this.files
                this.$store.commit('DELETE_FILE_EMPLOYEE', false);
            }
        },
        '$store.state.isDeleteFileNotId'(val) {
            if (val) {
                let index = this.files.indexOf(val)
                this.files.splice(index, 1)
                this.filesGrid = []
                setTimeout(() => {
                    this.filesGrid = this.files
                })
                this.$store.commit('DELETE_FILE_EMPLOYEE_NOT_ID', false);
            }
        }
    },

    async created() {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.filter(x => x.organizationBranchType !== 3).map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });

        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({ value: i, label: utils.minuteToHour(i) });
        }
        this.timeSpans = timeSpans;
        this.getDepartment();
        // this.loadWorkShiftSetting();
        await this.getPermission()
        await this.getClassRoomPermission()

        let employeeId = this.$route.query.id;
        if (employeeId) {
            await this.getUserInfo(employeeId);
            for (const x of this.employeeInfo.fileManagers.filter(el => el.fileManagerType == 1)) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.fileName, metadata);
                this.images.push({
                    name: x.fileName,
                    path: data.imgBase64,
                    highlight: 1,
                    default: 1,
                    file: file
                });
            }
            let files = this.employeeInfo.fileManagers.filter(el => el.fileManagerType == 4)

            if (files.length > 0) {
                for (const el of files) {
                    let blob = await this.getBlobFromUrl(el);
                    let file = new File([blob], el.name, { type: el.fileType })
                    file['id'] = el.id;
                    file['metaData'] = JSON.parse(el.metaData);
                    this.files.push(file);
                }
                this.fileSelect = this.files[0];
                this.indexSelect = 0;
            }
            this.filesGrid = this.files;

            this.fileSelect = this.files[0];
            this.indexSelect = 0;

            if (!this.isUpdate) this.employeeInfo.gender = 2;
        }
        this.formatUnixTime();
        if (this.employeeInfo.birthday) this.employeeBirthday = this.employeeInfo.birthday
    },
    computed: {
        branchModel: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value == this.employeeInfo.organizationBranchId)),
                    value: this.employeeInfo.organizationBranchId
                }
            },
            set(obj) {
                this.employeeInfo.organizationBranchId = obj.value;
                this.loadWorkShiftSetting();
                this.getDepartment();
            }
        },
        departmentModel: {
            get() {
                return {
                    label: this.getLabelString(this.departmentOptions.find(x => x.value === this.employeeInfo.departmentId)),
                    value: this.employeeInfo.departmentId
                }
            },
            set(obj) {
                this.employeeInfo.departmentId = obj.value;
                // this.employeeInfo.departmentType = false;
                if (this.employeeInfo.departmentId) {
                    this.isShowManagerDepartment = true;
                } else {
                    this.isShowManagerDepartment = false;
                }
            }
        },
        validateForm() {
            return !this.errors.any()
        },
        genderModel: {
            get() {
                return {
                    label: this.getLabelString(this.genderOptions.find(x => x.value === this.employeeInfo.gender)),
                    value: this.employeeInfo.gender
                }
            },
            set(obj) {
                this.employeeInfo.gender = obj.value;
            }
        },
        employeeTypeModel: {
            get() {
                return {
                    label: this.getLabelString(this.employeeTypeOptions.find(x => x.value === this.employeeInfo.type)),
                    value: this.employeeInfo.type
                }
            },
            set(obj) {
                this.employeeInfo.type = obj.value;
            }
        },
        province: {
            get() {
                return {
                    label: this.getLabelString(this.cityOptions.find(x => x.value === this.employeeInfo.city)),
                    value: this.employeeInfo.city
                }
            },
            set(obj) {
                if (obj.value) {
                    this.employeeInfo.city = obj.value;
                    this.districtOptions = province.getDistrict(obj.value);
                    this.employeeInfo.district = this.districtOptions[0].value;
                    this.subDistrictOptions = province.getSubDistrict(this.employeeInfo.city, this.employeeInfo.district);
                    this.employeeInfo.street = this.subDistrictOptions[0].value;
                } else {
                    this.employeeInfo.city = null;
                    this.districtOptions = [{ value: null, label: this.$t('cardCustomer.allCard') }];
                    this.employeeInfo.district = null;
                    this.subDistrictOptions = [{ value: null, label: this.$t('cardCustomer.allCard') }];
                    this.employeeInfo.street = null;
                }
            }
        },
        district: {
            get() {
                return {
                    label: this.getLabelString(this.districtOptions.find(x => x.value === this.employeeInfo.district)),
                    value: this.employeeInfo.district
                }
            },
            set(obj) {
                this.employeeInfo.district = obj.value;
                this.subDistrictOptions = province.getSubDistrict(this.employeeInfo.city, obj.value);
                this.employeeInfo.street = this.subDistrictOptions[0].value;
            }
        },
        subDistrict: {
            get() {
                return {
                    label: this.getLabelString(this.subDistrictOptions.find(x => x.value === this.employeeInfo.street)),
                    value: this.employeeInfo.street
                }
            },
            set(obj) {
                this.employeeInfo.street = obj.value
            }
        },
        userNameModel: {
            get() {
                return this.employeeInfo.username;
            },
            set(val) {
                this.employeeInfo.username = val;
            }
        },
        firstNameModel: {
            get() {
                return this.employeeInfo.firstName;
            },
            set(value) {
                this.employeeInfo.firstName = value;
                this.changValueUserName();
            }
        },
        lastNameModel: {
            get() {
                return this.employeeInfo.lastName;
            },
            set(value) {
                this.employeeInfo.lastName = value;
                this.changValueUserName();
            }
        },

    },
    methods: {
        removeDots(input) {
            return input.replace(/\./g, '');
        },
        formatInput(event) {
            let value = event;
            value = String(value).replace(/\D/g, '');
            if (value) {
                value = Number(value).toLocaleString('vi-VN');
            }
            this.formattedSalary = value;
            this.employeeInfo.mainLessonSalary = this.removeDots(this.formattedSalary)
        },
        formatInputMoney(event) {
            let value = event;
            value = String(value).replace(/\D/g, '');
            if (value) {
                value = Number(value).toLocaleString('vi-VN');
            }
            this.formattedExtraSalary = value;
            this.employeeInfo.extraLessonSalary = this.removeDots(this.formattedExtraSalary)
        },
        formatUnixTime() {
            const date = new Date(this.employeeInfo.birthday);
            if (this.isUpdate) {
                const formatted = `${('0' + date.getDate()).slice(-2)}/${('0' + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
                this.employeeInfo.birthday = formatted;
            }

        },
        isPermissionEdit() {
            return isRouter(this, constRouter.employee_edit)
        },
        getPermission() {
            this.$vs.loading()
            this.$oauth.get('/position/find-all').then(res => {
                this.positionOptions = res.data.map(el => {
                    return {
                        value: el.id,
                        label: el.name
                    }
                })
                this.$vs.loading.close()
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        onGridReady() {
            // if (this.$store.state.windowWidth > 1024) {
            //     this.gridApi.sizeColumnsToFit()
            // }
        },
        customerType(type) {
            if (type === 0) this.employeeInfo.customerType = this.$t('cardCustomer.customer')
            if (type === 1) this.employeeInfo.customerType = this.$t('cardCustomer.employee')
            if (type === 2) this.employeeInfo.customerType = this.$t('cardCustomer.unknown')
        },
        chooseCard: function (card) {
            this.employeeInfo.cardNumber = card.cardStaffId;
            this.employeeInfo.cardStaffType = card.cardStaffType;
            this.employeeInfo.cardId = card.value;
            this.customerType(card.cardStaffType);
            this.activePopup = false;
        },
        openPopupCard: function () {
            this.activePopup = true;
        },
        checkKeypressDrop: function (event) {
            event.target.value = event.target.value.trim();
            return event;
        },
        changValueUserName: function () {
            if (this.isUpdate || !this.employeeInfo.lastName || !this.employeeInfo.firstName) {
                return
            }
            let username = `${this.employeeInfo.firstName ? this.employeeInfo.lastName : ''}`
            const firstNames = this.employeeInfo.firstName.split(' ');
            firstNames.forEach(item => {
                username += item.substr(0, 1)
            });
            this.employeeInfo.username = username
                .split(' ')
                .join('')
                .replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, "a")
                .replace(/[èéẹẻẽêềếệểễ]/g, "e")
                .replace(/[ìíịỉĩ]/g, "i")
                .replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, "o")
                .replace(/[ùúụủũưừứựửữ]/g, "u")
                .replace(/[ỳýỵỷỹ]/g, "y")
                .replace(/đ/g, "d")
                .replace(/[ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ]/g, "A")
                .replace(/[ÈÉẸẺẼÊỀẾỆỂỄ]/g, "E")
                .replace(/[ÌÍỊỈĨ]/g, "I")
                .replace(/[ÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ]/g, "O")
                .replace(/[ÙÚỤỦŨƯỪỨỰỬỮ]/g, "U")
                .replace(/[ỲÝỴỶỸ]/g, "Y")
                .replace(/Đ/g, "D")
                .replace(/[\u0300\u0301\u0303\u0309\u0323]/g, "")
                .replace(/[\u02C6\u0306\u031B]/g, "")
                .replace(/[!@%^*()+=<>?\/,.:;'"&#\[\]~$_`\-{}|\\]/g, " ")
                .trim()
                .toLowerCase();
        },
        checkUserName: function () {
            return new Promise((resolve, reject) => {
                this.$oauth.get(`/user/check-username?username=${this.employeeInfo.username}`).then((response) => {
                    this.$vs.loading.close();
                    if (!response.data) {
                        resolve();
                        this.$vs.notify({
                            color: 'success',
                            text: this.$t('menuOrganization.validUsername'),
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        });
                        this.checkUsernameExisted = response.data;
                    } else {
                        reject();
                        this.$vs.notify({
                            color: 'danger',
                            text: this.$t('menuOrganization.userExists'),
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        });
                        this.checkUsernameExisted = response.data;
                    }
                })
            })
        },
        async changePassword(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;

            const result = await this.$validator.validateAll();
            if (!result) return;

            let url = "/user/org-reset-password";
            this.$oauth.post(url, null, {
                params: {
                    employeeCode: this.employeeInfo.employeeCode,
                    password: this.newPassword
                }
            }).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `Thay đổi mật khẩu thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$router.push(`/user/manage-employee${this.password ?
                    `?branch_id=${this.password}` : ''}`).catch(() => {
                    })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({ imgBase64: reader.result, xhr: xhr });
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },
        checkLengthUserName() {
            if (this.userNameModel.length > 50) {
                this.isMaxLength = true
                this.userNameModel = this.userNameModel.trim();
            } else {
                this.isMaxLength = false
                this.userNameModel = this.userNameModel.trim();
            }
        },
        getUserInfo(employeeId) {
            this.$vs.loading();
            return new Promise(resolve => {
                this.$vs.loading();
                this.$crm.post('/employee/find-by-id/' + employeeId).then(async (response) => {

                    if (response.data.departmentDTO) {
                        response.data.departmentId = response.data.departmentDTO.id;
                        this.isShowManagerDepartment = true;
                    } else {
                        response.data.departmentId = null;
                    }
                    delete response.data.departmentDTO;

                    if (response.data.positions) {
                        let result = this.positionOptions.map(el => {
                            let p = response.data.positions.find(t => t === el.value)
                            if (p) {
                                return {
                                    value: p,
                                    label: el.label
                                }
                            }
                        })
                        this.selectedPositions = result.filter(t => t);
                    }

                    if (response.data.managedClassRooms.length > 0) {
                        response.data.managedClassRooms.forEach(el => {
                            let classroom = this.dataClassPermission.find(x => x.id === el.id)
                            if (classroom) this.selectedClassroom.push(classroom)
                        })
                        this.selectedClassroom.sort((a, b) => a.organizationBranchId - b.organizationBranchId)
                    }

                    this.employeeInfo = response.data;
                    this.employeeInfo.cardId = response.data.cardId;
                    if (this.employeeInfo.cardId) {
                        this.customerType(1)
                        this.employeeInfo.cardStatus = 1;
                    }
                    if (response.data.cardStaff) this.employeeInfo.cardNumber = response.data.cardStaff.cardNumber;
                    this.employeeInfo.cardStaffType = 1;
                    // let dataImage = response.data.fileManagers;
                    // if (dataImage && dataImage.length > 0) this.employeeInfo.urlImage = dataImage[0].url;
                    if (this.employeeInfo && !this.employeeInfo.username) this.changValueUserName();
                    this.districtOptions = province.getDistrict(this.employeeInfo.city);
                    this.subDistrictOptions = province.getSubDistrict(this.employeeInfo.city, this.employeeInfo.district);

                    this.formattedExtraSalary = this.employeeInfo.extraLessonSalary
                    this.formattedSalary = this.employeeInfo.mainLessonSalary
                    this.formatInput(this.employeeInfo.mainLessonSalary)
                    this.formatInputMoney(this.employeeInfo.extraLessonSalary)
                    // if (Array.isArray(this.employeeInfo.workShiftSetting)) {
                    //     this.workShiftSetting.forEach(item => {
                    //         let setting = this.employeeInfo.workShiftSetting.find(setting => {
                    //             return item.id == setting.workShiftSettingId;
                    //         })
                    //         if (setting) {
                    //             item.select = true;
                    //             item.autoGenerateWorkShift = setting.autoGenerateWorkShift;
                    //         } else {
                    //             item.select = false
                    //             item.autoGenerateWorkShift = false;
                    //         }
                    //     })
                    // }
                    // await this.getAllPermission(this.employeeInfo.privileges);
                    // this.isShowPermission = true;
                    this.isUpdate = true;
                    resolve(true);
                    this.$vs.loading.close();
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        createDepartment() {
            this.employeeInfo.departmentId = null;
            this.isShowManagerDepartment = false;
            this.departmentName = null;
            this.isCreateDepartment = true;
        },
        saveDepartment() {
            if (!this.departmentName) {
                return this.$vs.notify({
                    text: this.$t('menuOrganization.cannotName'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            let dataRequest = {
                departmentName: this.departmentName,
                organizationBranchId: this.employeeInfo.organizationBranchId
            }
            this.$vs.loading();
            this.$crm.post('/department/create', dataRequest).then((response) => {
                this.isCreateDepartment = false;
                this.getDepartment();
                setTimeout(() => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: 'success',
                        text: `${this.$t('warningMenuOrganization.newDepartments')} ${this.departmentName} ${this.$t('warningMenuOrganization.success')}`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                }, 200)
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        cancelCreateDeparment() {
            this.isCreateDepartment = false;
        },
        getDepartment() {
            this.$vs.loading();
            let searchInfo = {
                organizationBranchId: this.employeeInfo.organizationBranchId
            }
            this.$crm.post('/department/find-by-condition', searchInfo).then((response) => {
                this.departmentOptions = response.data.map(x => {
                    return {
                        value: x.id,
                        label: x.departmentName
                    }
                });
                this.departmentOptions.unshift({ value: null, label: this.$t('employeeTypeOptions.unknown') });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        // getAllPermission(arrPermissions) {
        //     this.$vs.loading();
        //     return new Promise(resolve => {
        //         this.$oauth.get('/permission').then((response) => {
        //             let permissions = response.data.reduce((groups, item) => {
        //                 const group = (groups[this.$i18n.locale == 'vn' ? item.aliasGroupName : item.aliasGroupNameEng] || []);
        //                 group.push(item);
        //                 groups[this.$i18n.locale == 'vn' ? item.aliasGroupName : item.aliasGroupNameEng] = group;
        //                 return groups;
        //             }, {});
        //             for (const property in permissions) {
        //                 let permission = {
        //                     text: property,
        //                     children: [],
        //                     icon: "fa fa-warning icon-state-danger",
        //                     opened: true,
        //                 }
        //                 permissions[property].forEach(value => {
        //                     value.text = this.$i18n.locale == 'vn' ? value.aliasName : value.aliasNameEng;
        //                     value.icon = "fa fa-warning icon-state-danger";
        //                     value.opened = true;
        //                     if (arrPermissions) {
        //                         arrPermissions.filter(x => {
        //                             if (x == value.name) {
        //                                 value.selected = true;
        //                                 this.privileges.push(value.id);
        //                             }
        //                         })
        //                     }
        //                     permission.children.push(value);
        //                 })
        //                 let selectedFullChild = 0;
        //                 permission.children.forEach(x => {
        //                     if (x.selected == true) selectedFullChild++;
        //                 })
        //                 if (permission.children.length == selectedFullChild) permission.selected = true;
        //                 this.permissions.push(permission);
        //                 this.$vs.loading.close();
        //             }
        //             resolve(true);
        //         });
        //     })
        // },
        itemClick(node) {
            if (node.data.children && node.data.children.length > 0) {
                if (node.data.selected) {
                    node.data.children.forEach(x => {
                        let privilege = this.privileges.find(privilege => privilege == x.id);
                        if (!privilege) this.privileges.push(x.id);
                    })
                } else {
                    node.data.children.forEach(x => {
                        this.privileges = this.privileges.filter(privilege => privilege != x.id);
                    })
                }
            } else {
                if (node.data.selected) {
                    this.privileges.push(node.data.id);
                } else {
                    this.privileges = this.privileges.filter(x => x != node.data.id);
                }
            }
        },
        uploadImageSuccess(formData, index, fileList, file) {
            this.images = fileList;
            // this.employeeInfo.urlImage = fileList.length > 0 ? fileList[0].path : null;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
            done();
        },
        editImage(formData, index, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        dataChange(data) {
            this.images = fileList;
            // this.employeeInfo.urlImage = data;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },
        getLabelString(object) {
            return (object && object.label) || this.$t('menuOrganization.null');
        },
        manufactureString(type) {
            let typeString = this.manufactureOptions.find(x => x.value === type);
            return (typeString && typeString.label) || this.$t('menuOrganization.null');
        },
        loadWorkShiftSetting() {
            this.$vs.loading();
            this.$crm.post('/work-shift/organization/find-by-organization-branch/' + this.employeeInfo.organizationBranchId).then((response) => {
                this.workShiftSetting = response.data.workShiftSetting.map(item => {
                    this.$vs.loading.close();
                    if (this.isUpdate) {
                        let setting = this.employeeInfo.workShiftSetting.find(setting => {
                            return item.id == setting.workShiftSettingId;
                        })
                        if (setting) {
                            item.select = true;
                            item.autoGenerateWorkShift = setting.autoGenerateWorkShift;
                        } else {
                            item.select = false
                            item.autoGenerateWorkShift = false;
                        }
                    } else {
                        item.select = true;
                        item.autoGenerateWorkShift = true;
                    }
                    item.displayWorkShift = "Nhóm " + item.groupName + " - Ca " + item.name + ": " + utils.minuteToHour(item.startHour) + "-" + utils.minuteToHour(item.endHour);
                    return item;
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        async saveChanges(evt) {

            evt.preventDefault();
            if (!this.validateForm) return;

            const result = await this.$validator.validateAll();
            if (!result) return;

            const isoBirthday = moment(this.employeeBirthday, "DD/MM/YYYY")._d.toISOString();
            this.employeeInfo.birthday = isoBirthday;
            if (new Date(this.employeeInfo.birthday).getTime() > new Date().getTime()) {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('menuOrganization.theFuture'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if (!this.isUpdate) {
                await this.checkUserName();
                if (this.checkUsernameExisted) return;
            }
            // this.employeeInfo.workShiftSetting = this.workShiftSetting.reduce((arr, item) => {
            //     if (item.select) {
            //         arr.push({ workShiftSettingId: item.id, autoGenerateWorkShift: item.autoGenerateWorkShift ? 1 : 0 });
            //     }
            //     return arr;
            // }, []);
            if (this.employeeInfo.firstName && this.employeeInfo.lastName) {
                this.employeeInfo.fullName = this.employeeInfo.lastName.trim() + " " + this.employeeInfo.firstName.trim();
            }
            this.employeeInfo.privileges = this.privileges;
            // if (this.employeeInfo.departmentType) {
            //     this.employeeInfo.departmentType = 1
            // } else {
            //     this.employeeInfo.departmentType = 0;
            // }
            if ( !this.employeeInfo.mainLessonSalary){
                this.employeeInfo.mainLessonSalary = 0
            }
            if ( !this.employeeInfo.extraLessonSalary){
                this.employeeInfo.extraLessonSalary = 0
            }
            //update by school
            this.employeeInfo.departmentType = parseInt(this.employeeInfo.departmentType);

            // if(this.isUpdate && this.images.length == 0 && this.employeeInfo.imageStore.length > 0) {
            //     return this.$vs.notify({
            //         text: this.$t('employeeScreen.requiredImage'),
            //         iconPack: 'feather',
            //         icon: 'icon-alert-circle',
            //         color: 'danger'
            //     });
            // }

            if (!this.employeeInfo.employeeCode) {
                return this.$vs.notify({
                    text: this.$t('employeeScreen.requiredEmployeeId'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.firstName) {
                return this.$vs.notify({
                    text: this.$t('employeeScreen.requiredFirstName'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.firstName) {
                return this.$vs.notify({
                    text: this.$t('employeeScreen.requiredLastName'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.username) {
                return this.$vs.notify({
                    text: this.$t('employeeScreen.requiredUsername'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.birthday) {
                return this.$vs.notify({
                    text: this.$t('employeeScreen.requiredBirth'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.email) {
                return this.$vs.notify({
                    text: this.$t('employeeScreen.requiredEmail'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if (!this.isUpdate || (this.isUpdate && this.isUpdateImages)) {
                if (this.images.length > 0) {
                    await this.handleClickUploadFile();
                    this.employeeInfo.images = this.imagesId;
                } else {
                    this.employeeInfo.images = []
                }
            }

            if (this.selectedPositions.length > 0) {
                this.employeeInfo.positions = this.selectedPositions.map(x => x.value)
            } else {
                this.employeeInfo.positions = []
            }

            if (this.selectedClassroom.length > 0) {
                this.employeeInfo.teacherClassroomIds = this.selectedClassroom.map(el => el.id)
            } else {
                this.employeeInfo.teacherClassroomIds = []
            }

            this.employeeInfo.isSchool = true;
            let url = this.isUpdate ? `/employee/update/${this.employeeInfo.employeeId}` : `/employee/create-single/${this.employeeInfo.organizationBranchId}`;

            let formData = new FormData(), config = {};
            config = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            };
            const blob = new Blob([JSON.stringify(this.employeeInfo)], { type: 'application/json' });
            formData.append('dto', blob);

            if (this.files.length > 0) {
                if (this.isUpdate) {
                    let listFile1 = this.files.filter(el => el.id),
                        listFile2 = [];
                    if (this.employeeInfo.fileManagers.length > 0) listFile2 = this.employeeInfo.fileManagers.filter(el => el.fileManagerType === 4)
                    if (listFile1.length !== this.files.length || listFile2.length !== this.files.length) {
                        this.files.forEach(el => {
                            if (el.id) delete el.id;
                            formData.append('files', el);
                        })
                    } else this.files.forEach(el => formData.append('files', el))
                } else {
                    this.files.forEach(el => formData.append('files', el))
                }
            }


            this.$vs.loading();
            this.$crm.post(url, formData, config).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('button.update') : this.$t('button.create')} ${this.$t('menuOrganization.succPersonnel')}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$router.push('/user/manage-employee')
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        confirmHandleClickUploadFile() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('button.titleDelete'),
                text: this.$t('menuOrganization.oldData'),
                accept: this.handleClickUploadFile,
                acceptText: this.$t('statusActive.agree'),
                cancelText: this.$t('statusActive.cancel')
            })
        },
        handleClickUploadFile() {
            return new Promise((resolve) => {
                let formData = new FormData(), config = {};
                this.images.forEach((f, i) => {
                    formData.append('files', f.file);
                });
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };

                this.$vs.loading();
                this.$crm.post('/employee/image/upload', formData, config).then((res) => {
                    this.imagesId = [];
                    this.imagesId = res.data;
                    resolve(true);
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            });
        },
        employeeList() {
            this.$router.push(`/user/manage-employee${this.employeeInfo.organizationBranchId ? `?branch_id=${this.employeeInfo.organizationBranchId}` : ''}`).catch(() => {
            })
        },

        uploadFile() {
            let file = this.$refs.fileUpload.files,
                files = [];
            files.push(...file);
            let checkSize = files.find(el => el.size > 20000000);
            this.$refs.fileUpload.value = null;
            if (checkSize) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Kích thước tệp không được vượt quá 20MB',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }
            let checkFile = files.filter(el => !(/\.(doc|docx|pdf|epub)$/.test(el.name)));
            if (checkFile.length > 0) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Chỉ hỗ trợ tệp có định dạng .doc, .docx, .pdf, .epub',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }
            this.files.push(...files);
            this.fileSelect = this.files[0];
            this.filesGrid = [];
            setTimeout(() => {
                this.filesGrid = this.files
            })
        },

        isCheckFile(file) {
            return /\.(doc|docx|pdf|epub)$/.test(file.name)
        },

        dragoverFile(e) {
            if (this.files.length === 0) {
                e.preventDefault();
                this.isDragging = true;
            }
        },
        dragleaveFile() {
            if (this.files.length === 0) {
                this.isDragging = false;
            }
        },
        dropFile(e) {
            if (this.files.length === 0) {
                e.preventDefault();
                this.$refs.fileUpload.files = e.dataTransfer.files;
                this.uploadFile();
                this.isDragging = false;
            }
        },

        deleteFile() {
            this.files.splice(this.indexSelect, 1);
            this.fileSelect = this.files[0];
            this.indexSelect = 0;
        },

        showFile(file, ind) {
            this.fileSelect = file;
            this.indexSelect = ind;
        },

        getBlobFromUrl(url) {
            return new Promise((resolve, reject) => {
                let request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.responseType = 'blob';
                request.onload = () => {
                    resolve(request.response);
                };
                request.onerror = reject;
                request.send();
            })
        },

        getClassRoomPermission() {
            return new Promise((resolve, reject) => {
                let payload = {
                    status: true,
                }

                this.$vs.loading()
                this.$crm.post('/school-classroom/get-all-class', payload).then(res => {
                    let branchList = JSON.parse(localStorage.getItem('branchInfoList'))
                    if (res.data.length > 0) {
                        this.dataClassPermission = res.data.map(el => {
                            let branch = branchList.find(x => x.id === el.organizationBranchId)
                            if (branch) el.organizationBranchName = branch.organizationBranchName
                            return el
                        })

                        this.dataClassPermission.sort((a, b) => a.organizationBranchId - b.organizationBranchId)
                    }
                    resolve(res)
                    this.$vs.loading.close()
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        }
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style lang="scss">
.heightDropdown .vs__dropdown-menu {
    height: 150px !important;
}

.file-upload {
    width: 200px;
    height: 200px;
    border: dashed 2px rgba(var(--vs-primary), 1);
    border-radius: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .button-upload button {
        border-radius: 1.5rem;
    }

    .file-label {
        color: #C0C0C0;
    }
}

.show-list-file {
    .list-file {
        width: 200px;
        margin-top: 0.5rem;
    }

    .add-file {
        border: 1px solid rgba(var(--vs-primary), 1);
        border-radius: 0.25rem;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
    }
}
</style>
